import React from "react";
import { confirmable } from "react-confirm";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Button,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const DialogTitle = ({ children, onClose }) => (
  <div className="d-flex flex-space-between flex-center" style={{ padding: "16px 24px" }}>
    <Typography variant="body" className="dialogTitle p-0 mt-25 dark:text-white">
      {children}
    </Typography>
  </div>
);

class Confirmation extends React.Component {
  render() {
    const {
      okLabel = "OK",
      cancelLabel = "Cancel",
      title,
      confirmation,
      show,
      proceed,
      dismiss,
      cancel,
    } = this.props;

    return (
      <Dialog open={show} onClose={dismiss} fullWidth maxWidth="sm">
        <DialogTitle onClose={dismiss} className="dark:bg-[#1A1F2C] dark:text-white">{title || "Confirmation"}</DialogTitle>
        <DialogContent className="mb-10 dark:bg-[#1A1F2C]" style={{ fontWeight: "600" }}>
          <div className="dark:text-[#F1F5F9]" style={{ lineHeight: "20px", fontSize: "14px" }}>
            {confirmation}
          </div>
        </DialogContent>
        {(proceed || cancel) && (
          <DialogActions className="mt-20 mb-15 dark:bg-[#1A1F2C]">
            {cancel && (
              <Button
                variant="outlined"
                onClick={cancel}
                className="mr-10"
                style={{
                  backgroundColor: "gray",
                  color: "white",
                  borderRadius: "5px",
                  padding: "8px 16px",
                }}
              >
                {cancelLabel}
              </Button>
            )}
            {proceed && (
              <Button
                variant="contained"
                onClick={proceed}
                className="mr-5"
                style={{
                  backgroundColor: "green",
                  color: "white",
                  borderRadius: "5px",
                  padding: "8px 16px",
                }}
              >
                {okLabel}
              </Button>
            )}
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

export default confirmable(Confirmation);
